import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import {NFTContarct, USDTContarct } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";

import Nodata from "../assets/img/no-record-found.png"
import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
} from "react-icons/fa";
  const formatBalance = (balance) => balance ? parseFloat(balance).toFixed(2) : "0.00";

const LeaderBonus = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const [copiedIndex, setCopiedIndex] = useState(null);

  // INIT WEB3
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client?.transport) provider = client.transport;
      else if (window.ethereum) provider = window.ethereum;

      if (!provider) return;

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  // Fetch on connect
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchLevelBonus();
    }
  }, [address, isConnected, web3]);

  // ----------------------------------------------------------------------
  // ✅ Fetch reward_details() with new structure
  // ----------------------------------------------------------------------
  const fetchLevelBonus = async () => {
    try {
      const contract = new web3.eth.Contract(NFTABI, NFTContarct);

      const result = await contract.methods.reward_details(address).call();

      console.log("📌 RAW Response =", result);

      const reward_timestamp = result._reward_timestamp || [];
      const reward_credited = result._reward_credited || [];
      const reward_type = result._reward_type || [];
      const reward_level = result._reward_level || [];
      const reward_from = result._reward_from || [];
      const reward_tokenId = result.tokenId || [];

      let finalList = [];

      for (let i = 0; i < reward_type.length; i++) {
        // You said: type = 1 → Level Bonus
        if (Number(reward_type[i]) === 1) {
          finalList.push({
            from: reward_from[i],
            amount: Web3.utils.fromWei(reward_credited[i].toString(), "ether"),
            timestamp: new Date(Number(reward_timestamp[i]) * 1000).toLocaleString(),
            level: Number(reward_level[i]),
            tokenId: reward_tokenId[i]?.toString(),
          });
        }
      }

      console.log("🎉 Final Level Bonus List:", finalList);

      setBonusList(finalList.reverse());
    } catch (error) {
      console.error("❌ Error fetching reward_details:", error);
    }
  };

  // Pagination
  const safeList = Array.isArray(bonusList) ? bonusList : [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = safeList.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(safeList.length / recordsPerPage);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  // ----------------------------------------------------------------------
  // RETURN JSX (UI fully same as your old style)
  // ----------------------------------------------------------------------

  return (
    <div className="buyshheikh-page">
      <div className="pageTitle">
        <div className="section-title">
          <h2>
            <span className="text-warning"> NFT Trade </span>{" "}
           <span className="fw-lighter"> Earnings Details</span>
          </h2>
        </div>
      </div>

      <div className="mt-3">
        <div className="row">
          {currentRecords.length > 0 ? (
            currentRecords.map((item, index) => {
              const maskAddress =
                item.from && item.from.length > 6
                  ? item.from.substring(0, 4) +
                    "****" +
                    item.from.substring(item.from.length - 4)
                  : item.from;

              return (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="ref-card">
                    <div className="ref-card-body">

                      {/* S.No */}
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaHashtag className="ref-icon" /> S.No
                        </span>
                        <span className="ref-value">
                          {indexOfFirstRecord + index + 1}
                        </span>
                      </div>

                      {/* FROM WALLET */}
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaWallet className="ref-icon" /> From Wallet
                        </span>

                        <div className="ref-copy-box">
                          <span className="ref-value">{maskAddress}</span>

                          <button
                            className="copy-btn"
                            onClick={() => handleCopy(item.from, index)}
                          >
                            {copiedIndex === index ? (
                              <FaCheck className="copy-icon copied" />
                            ) : (
                              <FaCopy className="copy-icon" />
                            )}
                          </button>
                        </div>
                      </div>

                      {/* AMOUNT */}
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaMoneyBillWave className="ref-icon" /> Amount (USDT)
                        </span>
                        <span className="ref-badge">{formatBalance(item.amount)}</span>
                      </div>

                      {/* LEVEL */}
                      {/* <div className="ref-row">
                        <span className="ref-label">
                          <FaBoxOpen className="ref-icon" /> Level
                        </span>
                        <span className="ref-value">{item.level}</span>
                      </div> */}

                      {/* Token ID */}
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaHashtag className="ref-icon" /> Token ID
                        </span>
                        <span className="ref-value">{item.tokenId}</span>
                      </div>

                      {/* Date & Time */}
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaClock className="ref-icon" /> Date & Time
                        </span>
                        <span className="ref-date">{item.timestamp}</span>
                      </div>

                    </div>
                  </div>
                </div>
              );
            })
          ) : (
             
	 <div className="no-data">
          <img src={Nodata} alt="" />
        </div>
		
		
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination-div">
            <ul className="pagination mb-0">
              {[...Array(totalPages)].map((_, idx) => (
                <li
                  key={idx}
                  className={`page-item ${
                    currentPage === idx + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderBonus;
